export default "__VITE_ASSET__ehVvYhC2__"